import React, { FunctionComponent, PropsWithChildren, useCallback, useEffect } from 'react';

import cross from '@/shared/assets/cross.svg';

import { useStopPlayingContent } from '../../../../player-manager/helpers/stop-playing-content';
import { useCleanError, useCurrentError } from '../../../../error-boundary-context/context';

import styles from './styles.module.css';

export const ErrorOverlay: FunctionComponent<PropsWithChildren> = ({ children }) => {
    const cleanError = useCleanError();
    const { onErrorClose } = useCurrentError() as { onErrorClose?: () => void };

    const stopPlayingContent = useStopPlayingContent();

    const onClose = useCallback(() => {
        stopPlayingContent();
        onErrorClose?.();
        cleanError();
    }, [cleanError, onErrorClose, stopPlayingContent]);

    const onKeyDown = useCallback(
        (e: KeyboardEvent) => {
            if (e.code === 'Escape') {
                e.preventDefault();
                onClose();
            }
        },
        [onClose]
    );

    useEffect(() => {
        document.addEventListener('keydown', onKeyDown);

        return () => document.removeEventListener('keydown', onKeyDown);
    }, [onKeyDown]);

    return (
        <div className={styles.root}>
            <button onClick={onClose} className={styles.closeButton}>
                <img src={cross} alt="" className={styles.closeIcon} />
            </button>
            {children}
        </div>
    );
};
